import { render, staticRenderFns } from "./HeaderSection.vue?vue&type=template&id=f71b64e4&"
import script from "./HeaderSection.vue?vue&type=script&lang=ts&"
export * from "./HeaderSection.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports